/**
 * Portal Manta · Helpers de artefato (Padrão 12.4)
 * Extraído de App.jsx v29.2 modular
 */
import React from 'react';
import { M, F } from '../../tokens/theme.js';
import { normalizarFonte } from '../agentes/normalizarFonte.jsx';

function HeaderArtefato({cliente, projeto, contrato, tipo, versao, data, autor, localizacaoMaster}){
  return (<div style={{
    background:M.bg, borderBottom:`3px solid ${M.accent}`,
    padding:'18px 28px', marginBottom:24, fontFamily:F.body,
  }}>
    <div style={{display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:24, flexWrap:'wrap'}}>
      <div style={{flex:'1 1 auto', minWidth:280}}>
        <div style={{fontFamily:F.mono, fontSize:9, letterSpacing:3, color:M.accent, marginBottom:4, textTransform:'uppercase'}}>
          MANTA ASSOCIADOS · {tipo || 'PORTAL'}
        </div>
        <div style={{fontFamily:F.display, fontSize:22, fontWeight:700, color:M.heading, lineHeight:1.2, marginBottom:4}}>
          {projeto}
        </div>
        <div style={{fontSize:12, color:M.muted, marginBottom:6}}>
          Cliente: <b style={{color:M.text}}>{cliente}</b>{contrato && <> · Contrato: <code style={{fontFamily:F.mono, fontSize:11, background:M.bgAlt, padding:'1px 6px'}}>{contrato}</code></>}
        </div>
        {localizacaoMaster && (<div style={{fontSize:10.5, color:M.muted, fontFamily:F.mono}}>
          📁 Master: <b>{localizacaoMaster}</b>
        </div>)}
      </div>
      <div style={{textAlign:'right', flexShrink:0, fontSize:10, fontFamily:F.mono, lineHeight:1.6, color:M.muted}}>
        <div>Versão: <b style={{color:M.accent}}>v{versao}</b></div>
        <div>Data:    <b style={{color:M.text}}>{data}</b></div>
        <div>Autor:   <b style={{color:M.text}}>{autor}</b></div>
      </div>
    </div>
  </div>);
}

function SubsecaoM({num, id, titulo, children}){
  return (<div id={id} style={{marginTop:28, scrollMarginTop:24}}>
    <h3 style={{fontFamily:F.display, fontWeight:600, fontSize:17, color:M.heading, marginBottom:10, display:'flex', alignItems:'baseline', gap:10}}>
      {num && <span style={{fontFamily:F.mono, fontSize:11, color:M.accent, fontWeight:700, letterSpacing:1, flexShrink:0}}>{num}</span>}
      <span>{titulo}</span>
    </h3>
    <div style={{lineHeight:1.65, fontFamily:F.body, fontSize:13, color:M.text}}>{children}</div>
  </div>);
}

function TabelaM({num, titulo, headers, rows}){
  return (<div style={{margin:'18px 0'}}>
    {(num || titulo) && (<div style={{display:'flex', alignItems:'baseline', gap:12, padding:'6px 12px', background:M.heading}}>
      {num && <span style={{fontFamily:F.mono, fontSize:10, color:'#fff', fontWeight:700, letterSpacing:1.5}}>{num}</span>}
      {titulo && <span style={{fontFamily:F.mono, fontSize:10, color:'#fff', textTransform:'uppercase', letterSpacing:1}}>{titulo}</span>}
    </div>)}
    <table style={{width:'100%', borderCollapse:'collapse', fontFamily:F.body, fontSize:12}}>
      <thead><tr style={{borderBottom:`2px solid ${M.border}`, background:M.bgAlt}}>
        {headers.map((h,i)=>(
          <th key={i} style={{textAlign:'left', padding:'8px 12px', fontSize:10.5, fontWeight:600, color:M.muted, textTransform:'uppercase', letterSpacing:.5}}>{h}</th>
        ))}
      </tr></thead>
      <tbody>
        {rows.map((r,i)=>(
          <tr key={i} style={{borderBottom:`1px solid ${M.borderSoft}`, background: i%2===0?'transparent':M.bgAlt}}>
            {r.map((c,j)=>(<td key={j} style={{padding:'8px 12px', color:M.text, verticalAlign:'top'}}>{c}</td>))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>);
}

function PreM({num, titulo, children}){
  return (<div style={{margin:'14px 0'}}>
    {(num || titulo) && (<div style={{display:'flex', alignItems:'baseline', gap:10, padding:'6px 12px', background:M.heading, fontFamily:F.mono, fontSize:10, letterSpacing:1.5}}>
      {num && <span style={{color:'#fff', fontWeight:700}}>{num}</span>}
      {titulo && <span style={{color:'#fff', textTransform:'uppercase'}}>{titulo}</span>}
    </div>)}
    <pre style={{fontFamily:F.mono, fontSize:11.5, background:M.bgDark, color:'#E5E7EB', padding:14, overflowX:'auto', margin:0, lineHeight:1.55}}>{children}</pre>
  </div>);
}

function CalloutM({num, tipo='info', label, children}){
  const cores = {info:M.accent, warn:M.yellow, danger:M.red, success:M.green};
  const cor = cores[tipo] || M.accent;
  return (<div style={{padding:'12px 16px', margin:'16px 0', background:M.bgAlt, borderLeft:`3px solid ${cor}`, fontFamily:F.body, fontSize:12.5, lineHeight:1.6, color:M.text}}>
    {(num || label) && (<div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', fontFamily:F.mono, fontSize:9.5, letterSpacing:1.5, color:cor, marginBottom:6, textTransform:'uppercase', fontWeight:600}}>
      <span>{label || tipo}</span>
      {num && <span>{num}</span>}
    </div>)}
    {children}
  </div>);
}

function WatermarkManta(){
  return (<div style={{textAlign:'center', padding:'12px 20px', color:M.light, fontSize:9.5, fontFamily:F.mono, letterSpacing:1.5, borderTop:`1px solid ${M.border}`, marginTop:32, opacity:0.7}}>
    DESENVOLVIDO POR MANTA ASSOCIADOS · Análise técnica de infraestrutura
  </div>);
}

function Fonte({f, compact}){
  if (!f) return null;
  const n = normalizarFonte(f);
  if (compact){
    return (<span style={{
      display:'inline-flex', alignItems:'center', gap:4, padding:'1px 6px',
      background:M.bgAlt, border:`1px solid ${M.borderSoft}`, borderRadius:3,
      fontFamily:F.mono, fontSize:9, color:M.muted, marginLeft:6, verticalAlign:'baseline',
    }} title={`${n.fonte}${n.fonteLocal?' · '+n.fonteLocal:''}${n.fonteData?' · '+n.fonteData:''}${n.fonteAutor?' · '+n.fonteAutor:''}`}>
      📎 {n.fonte.length>22?n.fonte.slice(0,22)+'…':n.fonte}
    </span>);
  }
  return (<div style={{
    padding:'6px 10px', background:M.bgAlt, borderLeft:`2px solid ${M.accent}`,
    fontFamily:F.body, fontSize:10.5, color:M.muted, lineHeight:1.5, marginTop:4,
  }}>
    <b style={{color:M.heading}}>📎 {n.fonte}</b>
    {n.fonteLocal && <> · <i>{n.fonteLocal}</i></>}
    {n.fonteData && <> · <code style={{fontFamily:F.mono, fontSize:9.5}}>{n.fonteData}</code></>}
    {n.fonteAutor && <> · <span style={{color:M.muted}}>{n.fonteAutor}</span></>}
    {n.fonteUrl && <> · <a href={n.fonteUrl} target="_blank" rel="noopener noreferrer" style={{color:M.blue, textDecoration:'none'}}>🔗 abrir</a></>}
  </div>);
}

function DadoNumerico({valor, unidade, f, fonte}){
  const fnt = f || fonte;
  return (<span style={{display:'inline-flex', alignItems:'baseline', gap:4}}>
    <span style={{fontFamily:F.mono, fontWeight:700, color:M.heading}}>{valor}{unidade && ' '+unidade}</span>
    {fnt && <Fonte f={fnt} compact={true}/>}
  </span>);
}

export { HeaderArtefato, SubsecaoM, TabelaM, PreM, CalloutM, WatermarkManta, Fonte, DadoNumerico };
